import { extractErrorMessages } from '@fukuri-admins/ui/common/Form/logics/extractErrorMessages';
import { ComponentProps } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { RadioField } from '..';

type RadioFieldProps = ComponentProps<typeof RadioField>;

type Props = {
  /** フォームフィールド名 */
  name: string;
  /** ラジオグループのProps（value, onValueChange は自動で設定） */
  radioGroup: Omit<RadioFieldProps['radioGroup'], 'onValueChange' | 'value'>;
  /** FieldWrapperのProps（htmlFor, errorMessages は自動で設定） */
  fieldWrapperProps: Omit<RadioFieldProps['fieldWrapperProps'], 'htmlFor' | 'errorMessages'>;
};

export const RadioFieldController: React.FC<Props> = ({ name, radioGroup, fieldWrapperProps }) => {
  const { control } = useFormContext();

  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ control, name });

  return (
    <RadioField
      fieldWrapperProps={{
        htmlFor: name,
        errorMessages: extractErrorMessages(error),
        ...fieldWrapperProps,
      }}
      radioGroup={{
        ...radioGroup,
        value,
        onValueChange: onChange,
      }}
    />
  );
};
